import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { fontSizes } from '../../../../configs/fontSize'
import { UseTimeZone } from '../../../common/hooks/useTimeZone'
import { UseTypeFontSize } from '../../../common/hooks/useTypeFontSize'
import { Element } from '../../../common/html/element'
import { Icon } from '../../../common/html/icon'
import { Table } from '../../../common/table'
import { TextEllipsisStaticLine } from '../../../common/textEllipsis/TextEllipsisStaticLine'
import { Tooltip } from '../../../common/tooltip'
import { FORMAT, formatDateTime } from '../../../helpers/datetime'
import { AmountCell } from '../AmountCell'
import {
  OVERDUE_TAX_DEBT_TABLES,
  TAX_ENFORCEMENT_HISTORY_TABLE,
  TAX_ENFORCEMENT_TABLE,
  getThStyle,
} from '../helper'
import {
  selectInvoiceEnforcementHistory,
  selectOverdueTaxDebt,
  selectOverdueTaxDebtHistory,
} from '../store/slice'
import classes from './index.module.scss'

const MAX_HEIGHT = {
  [fontSizes.Small.name]: 252,
  [fontSizes.Medium.name]: 272,
  [fontSizes.Large.name]: 284,
}

export const TableItem = ({ type }) => {
  const timezone = UseTimeZone()
  const typeFontSize = UseTypeFontSize()

  const isTaxDebt = type === OVERDUE_TAX_DEBT_TABLES.OVERDUE_TAX_DEBT_HISTORY
  const TABLE_COL_IDS = isTaxDebt
    ? TAX_ENFORCEMENT_TABLE
    : TAX_ENFORCEMENT_HISTORY_TABLE

  const rowIds = useSelector(
    selectOverdueTaxDebt((data) => {
      const result = isTaxDebt
        ? data.overdueTaxDebtHistory
        : data.invoiceEnforcementHistory
      if (!result) return []
      return result.map((item) => item.publicDateId)
    }),
  )

  return (
    <Element className={classes.tableContainer}>
      <Element className={classes.tableName} style={{ fontSize: 14 }}>
        <Translate value={`filingStatus.${type}`} />
        {!isTaxDebt && (
          <Tooltip
            tooltipContent="filingStatus.TOOLTIP_INVOICE"
            isI18n
            contentClass="dFlex"
            tooltipStyle={{ maxWidth: 400, textAlign: 'justify' }}
          >
            <Icon
              className="icon-info-circle"
              style={{ fontSize: 16, color: '#9c9c9c' }}
            />
          </Tooltip>
        )}
      </Element>
      <Element className={classes.table}>
        <Table
          ids={rowIds}
          getDataFromRedux={
            isTaxDebt
              ? selectOverdueTaxDebtHistory
              : selectInvoiceEnforcementHistory
          }
          schema={Object.keys(TABLE_COL_IDS).map((key) => {
            const colId = TABLE_COL_IDS[key]
            return {
              colId,
              title: 'filingStatus.' + key,
              isI18n: true,
              thStyle: {
                justifyContent:
                  colId === TABLE_COL_IDS.AMOUNT ? 'flex-end' : 'flex-start',
              },
              tdStyle: {
                textAlign: colId === TABLE_COL_IDS.AMOUNT ? 'right' : 'left',
              },
              parentThStyle: getThStyle(colId),
              render: (data, { rowId, locale }) => {
                switch (colId) {
                  case TABLE_COL_IDS.PUBLICATION_DATE:
                    return formatDateTime(data, FORMAT.DATE, locale, timezone)
                  case TABLE_COL_IDS.AMOUNT:
                    return (
                      <AmountCell
                        rowId={rowId}
                        data={data}
                        getDataFromRedux={
                          isTaxDebt
                            ? selectOverdueTaxDebtHistory
                            : selectInvoiceEnforcementHistory
                        }
                      />
                    )
                  default:
                    return (
                      <TextEllipsisStaticLine
                        text={data}
                        isI18n={false}
                        lineClamp={2}
                      />
                    )
                }
              },
            }
          })}
          noDataText={
            isTaxDebt
              ? 'filingStatus.NO_DATA_TAX_DEBT'
              : 'filingStatus.NO_DATA_INVOICE'
          }
          autoHeightMax={MAX_HEIGHT[typeFontSize]}
        />
      </Element>
    </Element>
  )
}
